import { render, staticRenderFns } from "./DiscountsBox.vue?vue&type=template&id=21f22416&"
import script from "./DiscountsBox.vue?vue&type=script&lang=js&"
export * from "./DiscountsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports